export const EXPERT_TYPES = {
  VICTIMS: 'victimExpertises',
  VEHICULES: 'vehiculeExpertises',
};
export const EXPERT_TYPE = {
  VICTIMS: 'victimExpertise',
  VEHICULES: 'vehiculeExpertise',
};
export const DOC_VICTIM_DOCUMENT_ID = '1';
export const DOC_VEHICLE_DOCUMENT_ID = '2';
export const DOC_ACCOUNTING_DOCUMENT_ID = '3';

export const TYPE = {
  VICTIM: 'victimExpertise',
  VEHICLE: 'vehiculeExpertise',
};
